// extracted by mini-css-extract-plugin
module.exports = {"textarea":"question-styles-module__textarea___uVRs_"};